// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App-logo {
    height: 40vmin;
    pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
    .App-logo {
        animation: App-logo-spin infinite 20s linear;
    }
}

.App-header {
    background-color: #0f0f10;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: calc(10px + 2vmin);
    color: white;
}

.App-link {
    color: #61dafb;
}

@keyframes App-logo-spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

/* News Ticker Marquee Animations */
@keyframes marquee {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(-50%);
    }
}

@keyframes marquee-vertical {
    0% {
        transform: translateY(0);
    }
    100% {
        transform: translateY(-50%);
    }
}

.animate-marquee {
    animation: marquee 20s linear infinite;
}

.animate-marquee-vertical {
    animation: marquee-vertical 30s linear infinite;
}

.animate-marquee:hover,
.animate-marquee-vertical:hover {
    animation-play-state: paused;
}

/* ─── Button Highlight Animation ─── */
@keyframes button-blink {
    0%, 100% {
        background-color: transparent;
        transform: scale(1);
        box-shadow: none;
    }
    50% {
        background-color: rgba(99, 102, 241, 0.3); /* Indigo/Blue-ish */
        transform: scale(1.15);
        box-shadow: 0 0 12px rgba(99, 102, 241, 0.6);
        border-radius: 9999px;
    }
}

.animate-blink-3s {
    animation: button-blink 1s ease-in-out 3; /* Blink 3 times (1s per cycle) */
}

/* ─── Card Action Highlight Animation ─── */
@keyframes card-action-blink {
    0%, 100% {
        background-color: transparent;
        box-shadow: none;
        border-color: #e2e8f0;
    }
    50% {
        background-color: rgba(34, 197, 94, 0.1); /* light green bg */
        box-shadow: 0 0 15px rgba(34, 197, 94, 0.4);
        border-color: rgba(34, 197, 94, 0.5);
    }
}

.animate-card-action-blink {
    animation: card-action-blink 0.75s ease-in-out 2;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI;QACI,4CAA4C;IAChD;AACJ;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA,mCAAmC;AACnC;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,+CAA+C;AACnD;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA,uCAAuC;AACvC;IACI;QACI,6BAA6B;QAC7B,mBAAmB;QACnB,gBAAgB;IACpB;IACA;QACI,yCAAyC,EAAE,oBAAoB;QAC/D,sBAAsB;QACtB,4CAA4C;QAC5C,qBAAqB;IACzB;AACJ;;AAEA;IACI,wCAAwC,EAAE,iCAAiC;AAC/E;;AAEA,4CAA4C;AAC5C;IACI;QACI,6BAA6B;QAC7B,gBAAgB;QAChB,qBAAqB;IACzB;IACA;QACI,wCAAwC,EAAE,mBAAmB;QAC7D,2CAA2C;QAC3C,oCAAoC;IACxC;AACJ;;AAEA;IACI,gDAAgD;AACpD","sourcesContent":[".App-logo {\n    height: 40vmin;\n    pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n    .App-logo {\n        animation: App-logo-spin infinite 20s linear;\n    }\n}\n\n.App-header {\n    background-color: #0f0f10;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-size: calc(10px + 2vmin);\n    color: white;\n}\n\n.App-link {\n    color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n/* News Ticker Marquee Animations */\n@keyframes marquee {\n    0% {\n        transform: translateX(0);\n    }\n    100% {\n        transform: translateX(-50%);\n    }\n}\n\n@keyframes marquee-vertical {\n    0% {\n        transform: translateY(0);\n    }\n    100% {\n        transform: translateY(-50%);\n    }\n}\n\n.animate-marquee {\n    animation: marquee 20s linear infinite;\n}\n\n.animate-marquee-vertical {\n    animation: marquee-vertical 30s linear infinite;\n}\n\n.animate-marquee:hover,\n.animate-marquee-vertical:hover {\n    animation-play-state: paused;\n}\n\n/* ─── Button Highlight Animation ─── */\n@keyframes button-blink {\n    0%, 100% {\n        background-color: transparent;\n        transform: scale(1);\n        box-shadow: none;\n    }\n    50% {\n        background-color: rgba(99, 102, 241, 0.3); /* Indigo/Blue-ish */\n        transform: scale(1.15);\n        box-shadow: 0 0 12px rgba(99, 102, 241, 0.6);\n        border-radius: 9999px;\n    }\n}\n\n.animate-blink-3s {\n    animation: button-blink 1s ease-in-out 3; /* Blink 3 times (1s per cycle) */\n}\n\n/* ─── Card Action Highlight Animation ─── */\n@keyframes card-action-blink {\n    0%, 100% {\n        background-color: transparent;\n        box-shadow: none;\n        border-color: #e2e8f0;\n    }\n    50% {\n        background-color: rgba(34, 197, 94, 0.1); /* light green bg */\n        box-shadow: 0 0 15px rgba(34, 197, 94, 0.4);\n        border-color: rgba(34, 197, 94, 0.5);\n    }\n}\n\n.animate-card-action-blink {\n    animation: card-action-blink 0.75s ease-in-out 2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
